function SmsMessageBubble({ children }) {
  return (
    <div className="relative max-w-[75%] rounded-3xl rounded-bl-[4px] bg-[#e9e9eb] px-4 py-3">
      <div className="relative z-[1] text-2xl font-regular text-black">{children}</div>
    </div>
  );
}

export const SmsPreview = ({ candidateText, refereeText }) => {
  return (
    <div className="flex w-full flex-col bg-white font-sans">
      <div className="flex flex-col items-center px-4 pb-4 pt-2">
        <div className="mb-1.5 flex h-16 w-16 flex-col items-center justify-end overflow-hidden rounded-full bg-[#c7c7d6]">
          <div className="mb-1 h-6 w-6 rounded-full bg-[#8e8ea0]" />
          <div className="h-6 w-10 rounded-t-full bg-[#8e8ea0]" />
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[17px] font-semibold tracking-tight text-black">From</span>
          <span className="mt-px text-[18px] leading-none text-[#007aff]">›</span>
        </div>
      </div>

      <div className="flex-1 px-4 pb-4">
        <div className="mb-4 text-center">
          <p className="text-[13px] leading-relaxed text-[#8e8e93]">Text Message · SMS</p>
          <p className="text-[13px] text-[#8e8e93]">14 Feb 2024 at 10:09 AM</p>
        </div>

        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <span className="text-xl font-medium text-neutral-6">Candidate SMS Preview</span>
            <div className="flex justify-start">
              <SmsMessageBubble>
                <span>
                  {candidateText}{' '}
                  <a href="#" className="text-[#007aff] underline">
                    https://link.checkmate.tech/bSkNJkN
                  </a>
                </span>
              </SmsMessageBubble>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-xl font-medium text-neutral-6">Referee SMS Preview</span>
            <div className="flex justify-start">
              <SmsMessageBubble>
                <span>
                  {refereeText}{' '}
                  <a href="#" className="text-[#007aff] underline">
                    https://link.checkmate.tech/bSkNJkN
                  </a>
                </span>
              </SmsMessageBubble>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
